import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const Users = () => {
    const [title, setTitle] = useState("Agregar Usuario");
    const [loading, setLoading] = useState(false);
    const [user_id, setUserId] = useState(0);
    const [name, setName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [users, setUsers] = useState([]);
    const [branches, setBranches] = useState([]);
    const [roles, setRoles] = useState([]);
    const [partners, setPartners] = useState([]);
    const [offices, setOffices] = useState([]);
    const [drivers, setDrivers] = useState([]); // Nuevo estado para conductores
    const [branch_id, setBranchId] = useState(0);
    const [rol_id, setRolId] = useState(0);
    const [partner_id, setPartnerId] = useState(0);
    const [office_id, setOfficeId] = useState(0);
    const [driver_id, setDriverId] = useState(0); // Nuevo estado para conductor_id
    const [showpasseye, setShowPassEye] = useState(false);
    const [showconfirmpasseye, setShowConfirmPassEye] = useState(false);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [is_new, setIsNew] = useState(false);
    const [status_filter, setStatusFilter] = useState(2);
    const [branch_filter, setBranchFilter] = useState(0);
    const [rol_filter, setRolFilter] = useState(0);
    const [partner_filter, setPartnerFilter] = useState(0);
    const [office_filter, setOfficeFilter] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        getBranches();
        getRoles();
        getPartners();
        getOffices();
        getDrivers(); // Llamar a la función para obtener conductores
        setTimeout(() => {
            initializeSelect2();
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const initializeSelect2 = () => {
        $('#branch_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#rol_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#partner_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#office_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#driver_id').select2({ width: "100%", dropdownParent: $('#modal-default') }); // Nuevo select2 para conductor
        $('#status_filter').select2({ width: "100%" });
        $('#branch_filter').select2({ width: "100%" });
        $('#rol_filter').select2({ width: "100%" });
        $('#partner_filter').select2({ width: "100%" });
        $('#office_filter').select2({ width: "100%" });
    };

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Inactivo', value: 0 }
    ];

    $('#branch_filter').on("change", function (e) {
        setBranchFilter(e.target.value);
    });

    $('#rol_filter').on("change", function (e) {
        setRolFilter(e.target.value);
    });

    $('#partner_filter').on("change", function (e) {
        setPartnerFilter(e.target.value);
    });

    $('#office_filter').on("change", function (e) {
        setOfficeFilter(e.target.value);
    });

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#branch_id').on("change", function (e) {
        setBranchId(e.target.value);
    });

    $('#rol_id').on("change", function (e) {
        setRolId(e.target.value);
    });

    $('#partner_id').on("change", function (e) {
        setPartnerId(e.target.value);
    });

    $('#office_id').on("change", function (e) {
        setOfficeId(e.target.value);
    });

    $('#driver_id').on("change", function (e) { // Nuevo handler para conductor
        setDriverId(e.target.value);
    });

    const getBranches = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-branches-users');
        const branchesArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.branch_id,
            };
        })
        setBranches(branchesArray);
    };

    const getRoles = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-roles-users');
        const rolesArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.rol_id,
            };
        })
        setRoles(rolesArray);
    };

    const getPartners = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-partners-users');
        const partnersArray = response.data.data.map(function (element) {
            return {
                label: element.name_partner,
                value: element.partner_id,
            };
        })
        setPartners(partnersArray);
    };

    const getOffices = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-offices-users');
        const officesArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setOffices(officesArray);
    };

    const getDrivers = async () => { // Nueva función para obtener conductores
        const response = await axios.get(ENDPOINT + 'get-all-drivers-trips');
        const driversArray = response.data.data.map(function (element) {
            return {
                label: element.name + ' ' + element.last_name,
                value: element.driver_id,
            };
        })
        setDrivers(driversArray);
    };

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("branch_filter", branch_filter);
        form.append("rol_filter", rol_filter);
        form.append("partner_filter", partner_filter);
        form.append("office_filter", office_filter);
        await axios.post(ENDPOINT + 'get-all-users', form).then((response) => {
            setUsers(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por usuario",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        setIsNew(true);
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("name", name);
        form.append("last_name", last_name);
        form.append("email", email);
        form.append("phone", phone);
        form.append("address", address);
        form.append("password", password);
        form.append("confirm_password", confirm_password);
        form.append("branch_id", branch_id);
        form.append("rol_id", rol_id);
        form.append("partner_id", partner_id);
        form.append("office_id", office_id);
        form.append("driver_id", driver_id); // Agregar driver_id al formulario
        if (user_id === 0) {
            await axios
                .post(ENDPOINT + "save-user", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-user/" + user_id, {
                    name: name,
                    last_name: last_name,
                    email: email,
                    phone: phone,
                    address: address,
                    branch_id: branch_id,
                    rol_id: rol_id,
                    partner_id: partner_id,
                    office_id: office_id,
                    driver_id: driver_id // Agregar driver_id en la actualización
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const handleSubmitPassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
        .put(ENDPOINT + "change-password-user/" + user_id, {
            password: password,
            confirm_password: confirm_password
        })
        .then((response) => {
            getAll();
            clearFieldPass();
            setLoading(false);
            $("#closemodalpass").trigger("click");
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        })
        .catch(function (error) {
            console.log(error);
            setLoading(true);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                timer: 3000,
                html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        });
    }

    const clearField = () => {
        setUserId(0);
        setName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setAddress('');
        setPassword('');
        setConfirmPassword('');
        setBranchId(0);
        setRolId(0);
        setPartnerId(0);
        setOfficeId(0);
        setDriverId(0); // Limpiar driver_id
        setTitle("Agregar Usuario");
        
        // Remover clases select2
        $('#branch_id').removeClass('select2');
        $('#rol_id').removeClass('select2');
        $('#partner_id').removeClass('select2');
        $('#office_id').removeClass('select2');
        $('#driver_id').removeClass('select2'); // Remover clase del nuevo select
        
        // Resetear valores de los select
        $('#branch_id').val('0').trigger('change');
        $('#rol_id').val('0').trigger('change');
        $('#partner_id').val('0').trigger('change');
        $('#office_id').val('0').trigger('change');
        $('#driver_id').val('0').trigger('change'); // Resetear nuevo select
        
        setTimeout(() => {
            // Volver a agregar clases y reinicializar select2
            $('#branch_id').addClass('select2');
            $('#rol_id').addClass('select2');
            $('#partner_id').addClass('select2');
            $('#office_id').addClass('select2');
            $('#driver_id').addClass('select2'); // Agregar clase al nuevo select
            initializeSelect2();
        }, 100);
    };

    const clearFieldPass = () => {
        setUserId(0);
        setPassword('');
        setConfirmPassword('');
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-user-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        setIsNew(false);
        $('#branch_id').removeClass('select2');
        $('#rol_id').removeClass('select2');
        $('#partner_id').removeClass('select2');
        $('#office_id').removeClass('select2');
        $('#driver_id').removeClass('select2'); // Remover clase del nuevo select
        await axios
            .get(ENDPOINT + "get-user/" + id)
            .then((response) => {
                setLoading(false);
                setUserId(response.data.data.user_id);
                setName(response.data.data.name);
                setLastName(response.data.data.last_name);
                setEmail(response.data.data.email);
                setPhone(response.data.data.phone);
                setAddress(response.data.data.address);
                setBranchId(response.data.data.branch_id);
                setRolId(response.data.data.rol_id);
                setPartnerId(response.data.data.partner_id);
                setOfficeId(response.data.data.office_id);
                setDriverId(response.data.data.driver_id || 0); // Establecer driver_id si existe
                setTitle("Editar Usuario");
                setTimeout(() => {
                    $('#branch_id').addClass('select2');
                    $('#rol_id').addClass('select2');
                    $('#partner_id').addClass('select2');
                    $('#office_id').addClass('select2');
                    $('#driver_id').addClass('select2'); // Agregar clase al nuevo select
                    initializeSelect2();
                }, 100);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-user/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("branch_filter", branch_filter);
        form.append("rol_filter", rol_filter);
        form.append("partner_filter", partner_filter);
        form.append("office_filter", office_filter);
        const response = await axios.post(ENDPOINT + 'print-pdf-users', form, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        setLoading(false);
    };

    const handlePassword = (id) => {
        setUserId(id);
        setTitle('Cambiar Contraseña de Usuario');
    };

    const showPassword = () => {
        setShowPassEye(!showpasseye);
    };

    const showConfirmPassword = () => {
        setShowConfirmPassEye(!showconfirmpasseye);
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return "";
        const date = new Date(dateTimeString);

        const meses = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        
        const dia = date.getDate();
        const mes = meses[date.getMonth()];
        const año = date.getFullYear();
        
        // Formatear hora
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const hours12 = (hours % 12 || 12).toString().padStart(2, '0');

        return `${dia} de ${mes} de ${año} a las ${hours12}:${minutes} ${ampm}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {title === "Agregar Usuario" ? <i className="fas fa-plus-circle me-2"></i> : <i className="fa-solid fa-pen-to-square me-2"></i>}
                                {title}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearField}></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="users-form-header">
                                    <h3 className="users-form-title">Información del Usuario</h3>
                                    <p className="users-form-subtitle">Complete los datos para crear o actualizar un usuario en el sistema</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                                Nombres <span className="users-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese nombres del usuario"
                                                id="name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                            <small className="users-field-hint">Nombres completos del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="last_name" className="col-form-label col-form-label-sm">
                                                Apellidos <span className="users-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese apellidos del usuario"
                                                id="last_name"
                                                name="last_name"
                                                value={last_name}
                                                onChange={(e) => setLastName(e.target.value)}
                                                required
                                            />
                                            <small className="users-field-hint">Apellidos completos del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="branch_id" className="col-form-label col-form-label-sm">
                                                Sucursal <span className="users-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="branch_id"
                                                name="branch_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {branches.map((item, index) => (
                                                    <option
                                                        selected={item.value === branch_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="users-field-hint">Seleccione la sucursal del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="rol_id" className="col-form-label col-form-label-sm">
                                                Rol del usuario <span className="users-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="rol_id"
                                                name="rol_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {roles.map((item, index) => (
                                                    <option
                                                        selected={item.value === rol_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="users-field-hint">Seleccione el rol del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="partner_id" className="col-form-label col-form-label-sm">
                                                Socio <span className="users-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="partner_id"
                                                name="partner_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {partners.map((item, index) => (
                                                    <option
                                                        selected={item.value === partner_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="users-field-hint">Seleccione el socio del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="office_id" className="col-form-label col-form-label-sm">
                                                Taquilla <span className="users-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="office_id"
                                                name="office_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {offices.map((item, index) => (
                                                    <option
                                                        selected={item.value === office_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="users-field-hint">Seleccione la taquilla del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="address" className="col-form-label col-form-label-sm">
                                                Dirección <span className="users-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese dirección del usuario"
                                                id="addres"
                                                name="address"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                                required
                                            />
                                            <small className="users-field-hint">Dirección de residencia del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="driver_id" className="col-form-label col-form-label-sm">
                                                Conductor
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="driver_id"
                                                name="driver_id"
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {drivers.map((item, index) => (
                                                    <option
                                                        selected={item.value === driver_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="users-field-hint">Seleccione el conductor asociado al usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="phone" className="col-form-label col-form-label-sm">
                                                Teléfono <span className="users-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese teléfono del usuario"
                                                id="phone"
                                                name="phone"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                            <small className="users-field-hint">Número de contacto del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="email" className="col-form-label col-form-label-sm">
                                                Email <span className="users-required">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese email del usuario"
                                                id="email"
                                                name="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            <small className="users-field-hint">Correo electrónico del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className={`form-group ${!is_new ? 'd-none' : ''}`}>
                                            <label htmlFor="password" className="col-form-label col-form-label-sm">
                                                Contraseña <span className="users-required">*</span>
                                            </label>
                                            <div className="position-relative">
                                                <input
                                                    type={!showpasseye ? 'password' : 'text'}
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese contraseña"
                                                    id="password"
                                                    name="password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <span 
                                                    className="position-absolute" 
                                                    style={{ 
                                                        right: '10px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)', 
                                                        cursor: 'pointer' 
                                                    }} 
                                                    onClick={showPassword}
                                                >
                                                    <i className={`fas ${!showpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                                </span>
                                            </div>
                                            <small className="users-field-hint">Contraseña para el acceso del usuario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className={`form-group ${!is_new ? 'd-none' : ''}`}>
                                            <label htmlFor="confirm_password" className="col-form-label col-form-label-sm">
                                                Confirmar contraseña <span className="users-required">*</span>
                                            </label>
                                            <div className="position-relative">
                                                <input
                                                    type={!showconfirmpasseye ? 'password' : 'text'}
                                                    className="form-control form-control-sm"
                                                    placeholder="Confirmar contraseña"
                                                    id="confirm_password"
                                                    name="confirm_password"
                                                    value={confirm_password}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                                <span 
                                                    className="position-absolute" 
                                                    style={{ 
                                                        right: '10px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)', 
                                                        cursor: 'pointer' 
                                                    }} 
                                                    onClick={showConfirmPassword}
                                                >
                                                    <i className={`fas ${!showconfirmpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                                </span>
                                            </div>
                                            <small className="users-field-hint">Confirme la contraseña del usuario</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {user_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={clearField}>
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-password" aria-labelledby="modal-password" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                <i className="fa-solid fa-key me-2"></i>
                                {title}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearFieldPass}></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmitPassword}>
                            <div className="password-recommendations p-3 mb-4" style={{ 
                                background: '#f8f9fa', 
                                border: '1px solid #dee2e6',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                            }}>
                                <h6 className="recommendations-title mb-3" style={{
                                    color: '#033c73',
                                    fontSize: '1rem',
                                    fontWeight: '600'
                                }}>
                                    <i className="fas fa-shield-alt me-2"></i>
                                    Recomendaciones para una contraseña segura
                                </h6>
                                <div className="recommendations-list" style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    <div className="recommendation-item" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.875rem',
                                        color: '#495057'
                                    }}>
                                        <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                        Al menos una letra mayúscula
                                    </div>
                                    <div className="recommendation-item" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.875rem',
                                        color: '#495057'
                                    }}>
                                        <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                        Al menos una letra minúscula
                                    </div>
                                    <div className="recommendation-item" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.875rem',
                                        color: '#495057'
                                    }}>
                                        <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                        Al menos un número
                                    </div>
                                    <div className="recommendation-item" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.875rem',
                                        color: '#495057'
                                    }}>
                                        <i className="fas fa-check-circle me-2" style={{ color: '#28a745' }}></i>
                                        Al menos un carácter especial
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                                Contraseña
                                            </label>
                                            <div className="position-relative">
                                                <input
                                                    type={!showpasseye ? 'password' : 'text'}
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese contraseña"
                                                    id="password"
                                                    name="password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <span 
                                                    className="position-absolute" 
                                                    style={{ 
                                                        right: '10px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)', 
                                                        cursor: 'pointer' 
                                                    }} 
                                                    onClick={showPassword}
                                                >
                                                    <i className={`fas ${!showpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="confirm_password" className="col-form-label col-form-label-sm">
                                                Confirmación contraseña
                                            </label>
                                            <div className="position-relative">
                                                <input
                                                    type={!showconfirmpasseye ? 'password' : 'text'}
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese confirmación"
                                                    id="confirm_password"
                                                    name="confirm_password"
                                                    value={confirm_password}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                />
                                                <span 
                                                    className="position-absolute" 
                                                    style={{ 
                                                        right: '10px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)', 
                                                        cursor: 'pointer' 
                                                    }} 
                                                    onClick={showConfirmPassword}
                                                >
                                                    <i className={`fas ${!showconfirmpasseye ? 'fa-eye' : 'fa-eye-slash'}`} style={{ color: "#033c73" }}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    Actualizar Contraseña
                                </button>
                                <button
                                    id="closemodalpass"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Usuarios" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-person me-2"></i> Listado de Usuarios
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="users-indications row mb-4">
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="users-field-hint">Filtra usuarios por su estado</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="branch_filter" className="col-form-label col-form-label-sm">
                                        Sucursal
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="branch_filter"
                                        name="branch_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {branches.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="users-field-hint">Filtra usuarios por sucursal</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="rol_filter" className="col-form-label col-form-label-sm">
                                        Rol
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="rol_filter"
                                        name="rol_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {roles.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="users-field-hint">Filtra usuarios por su rol</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="partner_filter" className="col-form-label col-form-label-sm">
                                        Socio
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="partner_filter"
                                        name="partner_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {partners.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="users-field-hint">Filtra usuarios por su socio</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="office_filter" className="col-form-label col-form-label-sm">
                                        Taquilla
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="office_filter"
                                        name="office_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {offices.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="users-field-hint">Filtra usuarios por su taquilla</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="d-flex justify-content-center items-align-center">
                                <div className="col-md-6 col-sm-6 col-xs-12 mt-3">
                                    <div className="form-group">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr className="text-center">
                                                    <td className="indications-table" width="30%" >Total</td>
                                                    <td className="indications-table" width="30%" >Activos</td>
                                                    <td className="indications-table" width="30%" >Inactivos</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td id="TuserT">{active + inactive}</td>
                                                    <td id="TuserA">{active}</td>
                                                    <td id="TuserI">{inactive}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Nombres</th>
                                    <th className="text-center">Apellidos</th>
                                    <th className="text-center">Sucursal</th>
                                    <th className="text-center">Rol</th>
                                    <th className="text-center">Socio</th>
                                    <th className="text-center">Taquilla</th>
                                    <th className="text-center">Conductor</th>
                                    <th className="text-center">Última Conexión</th>
                                    <th className="text-center">Estado</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.user_id}</kbd>
                                        </td>
                                        <td>
                                            {item.name}
                                        </td>
                                        <td>
                                            {item.last_name}
                                        </td>
                                        <td>
                                            {item.branch.name}
                                        </td>
                                        <td>
                                            {item.rol.name}
                                        </td>
                                        <td>
                                            {item.partner.name_partner}
                                        </td>
                                        <td>
                                            {item.office.name}
                                        </td>
                                        <td>
                                                    {item.driver_id ? 
                                                        (() => {
                                                         const driver = drivers.find(d => d.value === item.driver_id);
                                                         return driver ? driver.label : `Conductor ID: ${item.driver_id}`;
                                                                     })()
                                                                     : 'No asignado'
                                                                         }
                                                            </td>
                                        <td className="text-center">
                                            {formatDateTime(item.last_login)}
                                        </td>
                                        <td className="text-center">
                                            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.user_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    title="Editar registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        className="btn-sm btn btn-warning me-1"
                                                        onClick={() => handleEdit(item.user_id)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Eliminar registro"
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.user_id, item.name + ' ' + item.last_name)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                                <span
                                                    title="Cambiar contraseña"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-password"
                                                        className="btn btn-sm btn-dark"
                                                        onClick={() => handlePassword(item.user_id)}
                                                    >
                                                        <i className="fa-solid fa-key"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Users;